import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2, Sparkles, Home } from 'lucide-react';
import ProgressBar from '../components/ProgressBar';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Alert, AlertDescription } from '../components/ui/alert';

function ProcessingPage() {
  const { jobId } = useParams();
  const navigate = useNavigate();

  const handleProgressComplete = () => {
    if (jobId) {
      navigate(`/results/${jobId}`);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="min-h-screen">
      {/* Header */}
      <header className="bg-gradient-to-r from-emerald-600 to-teal-600 text-white shadow-lg">
        <div className="container mx-auto px-4 py-8">
          <div className="flex items-center justify-center gap-3">
            <Sparkles className="h-8 w-8" />
            <h1 className="text-3xl font-bold tracking-tight">Resume Screener</h1>
          </div>
          <p className="text-center mt-2 text-emerald-100">Processing your job screening request...</p>
        </div>
      </header>
      
      {/* Main Content */}
      <main className="container mx-auto px-4 py-8 max-w-2xl">
        <Card className="shadow-xl border-0 animate-fade-in">
          <CardHeader className="space-y-1 pb-4">
            <div className="flex items-center gap-2">
              <Loader2 className="h-5 w-5 text-emerald-600 animate-spin" />
              <CardTitle className="text-xl">Processing Resumes</CardTitle>
            </div>
          </CardHeader>
          
          <CardContent>
            {jobId ? (
              <ProgressBar jobId={jobId} onComplete={handleProgressComplete} />
            ) : (
              <div className="space-y-4">
                <Alert variant="destructive">
                  <AlertDescription>
                    Invalid job ID. Please start a new job screening.
                  </AlertDescription>
                </Alert>
                <Button onClick={() => navigate('/')} className="gap-2">
                  <Home className="h-4 w-4" />
                  Back to Home
                </Button>
              </div>
            )}
          </CardContent>
        </Card>
      </main>
    </div>
  );
}

export default ProcessingPage;
